import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from './button.component';

@Component({
  selector: 'app-save-btn',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveBtnComponent extends ButtonComponent {
  constructor() {
    super();
    this.icon = 'check';
    this.label = $localize`Zapisz`;
    this.style = 'primary';
    this.type = 'submit';
  }
}
